import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

declare global {
  interface Window {
    webkit?: any;
  }
}

const PushControl: React.FC = () => {
  const [pushLog, setPushLog] = useState("");
  const [iOSPushCapability, setIOSPushCapability] = useState(false);

  const logMessage = (message: string) => {
    let _toConsole = message;
    try {
      _toConsole = JSON.parse(message);
    } catch (e) {}
    console.log(_toConsole);
    setPushLog((prev) => prev + `>: ${message}\r\n`);
  };

  useEffect(() => {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers["push-permission-request"] &&
      window.webkit.messageHandlers["push-permission-state"]
    ) {
      setIOSPushCapability(true);
    }

    const onPushPermissionRequest = (event: any) => {
      if (event && event.detail) {
        logMessage(event.detail);

        switch (event.detail) {
          case "granted":
            // permission granted
            break;
          default:
            // permission denied
            break;
        }
      }
    };

    const onPushPermissionState = (event: any) => {
      if (event && event.detail) {
        logMessage(event.detail);

        switch (event.detail) {
          case "notDetermined":
            // permission not asked
            break;
          case "denied":
            // permission denied
            break;
          case "authorized":
          case "ephemeral":
          case "provisional":
            // permission granted
            break;
          case "unknown":
          default:
            // something wrong
            break;
        }
      }
    };

    const onPushNotification = (event: any) => {
      if (event && event.detail) {
        logMessage(JSON.stringify(event.detail));
      }
    };

    const onPushToken = (event: any) => {
      if (event && event.detail) {
        logMessage(JSON.stringify(event.detail));
      }
    };

    window.addEventListener("push-permission-request", onPushPermissionRequest);
    window.addEventListener("push-permission-state", onPushPermissionState);
    window.addEventListener("push-notification", onPushNotification);
    window.addEventListener("push-token", onPushToken);

    return () => {
      window.removeEventListener(
        "push-permission-request",
        onPushPermissionRequest
      );
      window.removeEventListener(
        "push-permission-state",
        onPushPermissionState
      );
      window.removeEventListener("push-notification", onPushNotification);
      window.removeEventListener("push-token", onPushToken);
    };
  }, []);

  const pushPermissionRequest = () => {
    if (iOSPushCapability) {
      window.webkit.messageHandlers["push-permission-request"].postMessage(
        "push-permission-request"
      );
    }
  };

  const pushPermissionState = () => {
    if (iOSPushCapability) {
      window.webkit.messageHandlers["push-permission-state"].postMessage(
        "push-permission-state"
      );
    }
  };

  const pushSubscribeTopic = (
    topic: string,
    eventValue: unknown,
    unsubscribe?: boolean
  ) => {
    if (iOSPushCapability) {
      window.webkit.messageHandlers["push-subscribe"].postMessage(
        JSON.stringify({
          topic, // topic name to subscribe/unsubscribe
          eventValue, // user object: name, email, id, etc.
          unsubscribe, // true/false
        })
      );
    }
  };

  const pushTokenRequest = () => {
    if (iOSPushCapability) {
      window.webkit.messageHandlers["push-token"].postMessage("push-token");
    }
  };

  return (
    <div className="p-6 bg-white shadow rounded">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Push Notifications</h2>
        <p>Firebase FCM</p>
      </div>
      <div className="flex space-x-2 mb-4">
        <Button variant="default" onClick={pushPermissionRequest}>
          Push Permission
        </Button>
        <Button variant="default" onClick={pushPermissionState}>
          Push State
        </Button>
      </div>
      <div className="flex space-x-2 mb-4">
        <Button
          onClick={() => pushSubscribeTopic("common", { userId: "1234" })}
        >
          Topic Subscribe
        </Button>
        <Button onClick={pushTokenRequest}>Token</Button>
      </div>
      <textarea
        readOnly
        className="w-full h-40 p-2 border rounded"
        value={pushLog}
        placeholder="events log"
      ></textarea>
    </div>
  );
};

export default PushControl;
